var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -636.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Activities",
    transform: "translate(1206.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,8.75 L25,8.75 L25,6.8125 L18,6.8125 L18,8.75 Z M18,16.5 L25,16.5 L25,14.5625 L18,14.5625 L18,16.5 Z M18,24.25 L25,24.25 L25,22.3125 L18,22.3125 L18,24.25 Z M11.085,10.032625 L10.047,11.0381875 L9.009,10.032625 L6.241,7.351125 C6.814,6.79603125 7.744,6.79603125 8.317,7.351125 L10.047,9.0270625 L13.162,6.010375 C13.735,5.45528125 14.665,5.45528125 15.238,6.010375 L11.085,10.032625 Z M8,17.46875 L12,17.46875 L12,13.59375 L8,13.59375 L8,17.46875 Z M8,25.21875 L12,25.21875 L12,21.34375 L8,21.34375 L8,25.21875 Z M23.994,1 L4.077,1 C4.034,1 4,1.0329375 4,1.07459375 L4,28.1065938 C4,30.2572187 5.799,32 8.019,32 L27.923,32 C27.966,32 28,31.9670625 28,31.9254062 L28,4.8808125 C28,2.73696875 26.207,1 23.994,1 L23.994,1 Z",
    id: 222
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonActivities);
export default __webpack_public_path__ + "static/media/common-activities.e529d065.svg";
export { ForwardRef as ReactComponent };